"use strict";

(function () {
  const onblur = ($field) => {
    $field.addEventListener("blur", (e) => {
      if ($field.value.trim() === "") {
        return;
      }
      if ($field.checkValidity()) {
        $field.classList.remove("is-invalid");
        $field.removeAttribute("aria-invalid");
        return;
      }

      $field.classList.add("is-invalid");
      $field.setAttribute("aria-invalid", true);
    });
  };

  document
    .querySelector("#recover_customer")
    ?.querySelectorAll("input")
    .forEach(onblur);
  document
    .querySelector("#create_customer")
    ?.querySelectorAll("input")
    .forEach(onblur);
  document
    .querySelector("#customer_login")
    ?.querySelectorAll("input")
    .forEach(onblur);

  const onsubmit = function (e) {
    const $fields = [...this.querySelectorAll("input")];
    const $invalid_fields = $fields.filter(($field) => !$field.checkValidity());

    $fields.forEach(($field) => {
      $field.value = $field.value.trim();

      if ($field.checkValidity()) {
        $field.classList.remove("is-invalid");
        $field.removeAttribute("aria-invalid");
      }
    });

    if ($invalid_fields.length === 0) {
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();

    $invalid_fields.forEach(($field) => {
      $field.classList.add("is-invalid");
      $field.setAttribute("aria-invalid", true);
    });

    $invalid_fields[0].focus();
  };

  document
    .querySelector("#create_customer")
    ?.addEventListener("submit", onsubmit);
  document
    .querySelector("#customer_login")
    ?.addEventListener("submit", onsubmit);
})();
